import styled, {css} from 'styled-components';

import {Button as BaseButton, EButtonSize, TButtonSize} from '../Button';
import {default as BaseDropdown, Overlay as BaseOverlay} from '../Dropdown';
import {default as BaseOption} from '../Option';
import {mixins} from '../styles';

export const Button = styled(BaseButton)`
  display: inline-flex;
  white-space: nowrap;
`;

export const Dropdown = styled(BaseDropdown)`
  width: fit-content;
`;

export const Option = styled(BaseOption)<{size: TButtonSize}>`
  ${({size, theme}) =>
    [EButtonSize.XXS, EButtonSize.XS].includes(size as EButtonSize)
      ? css`
          ${mixins.f2};
          line-height: 13px;
          height: 24px;
          padding: ${theme.spacing.s1} ${theme.spacing.s3};
        `
      : css`
          ${mixins.f3};
          line-height: 14px;
          height: 36px;
          padding: ${theme.spacing.s1} ${theme.spacing.s4};
        `};
`;

export const Overlay = styled(BaseOverlay)`
  overflow: hidden;
  box-shadow: ${({theme}) => theme.boxShadow.XS};
  text-align: left;
`;
